export default [
	{
		path: '/admin/service-requests',
		name: 'service-request',
		meta: { requiresAuth: true },
		component: () => import('@/pages/service-management/service-request/index.vue')
	},
	{
		path: '/admin/service-requests/create',
		name: 'service-request-create',
		meta: { requiresAuth: true },
		component: () => import('@/pages/service-management/service-request/create.vue')
	},
	{
		path: '/admin/service-requests/:id/edit',
		name: 'service-request-edit',
		meta: { requiresAuth: true },
		component: () => import('@/pages/service-management/service-request/edit.vue')
	},
	{
		path: '/admin/service-requests/generate-invoices',
		name: 'service-request-generate',
		meta: { requiresAuth: true },
		component: () => import('@/pages/service-management/service-request/generate-invoice.vue')
	},
	{
		path: '/admin/service-requests/:id/views',
		name: 'service-request-view',
		component: () => import('@/pages/service-management/service-request/view.vue')
	}
]
